import { apiRequest } from '@/utils/api-request';

interface TokenResponse {
  token: string;
}

export const getToken = async () => {
  const response = await apiRequest<TokenResponse>({
    url: '/user/current-token',
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get token' };
  }

  return response;
};
